import { Box, Button } from '@mui/material';
import { ReactElement, ReactNode } from 'react';

import { PaloModal } from './palo-modal';

export interface PaloDocumentPreviewProps {
    /** The document to show; nothing is shown while this is empty. */
    url?: string;
    title: ReactNode;
    /** The label of the button that opens the document in a tab of its own. */
    openLabel: ReactNode;
    closeLabel: ReactNode;
    onClose: () => void;
}

/**
 * The printed document, shown where the work is (#2206).
 *
 * "Drucken" used to throw the reader into a new browser tab, away from the mask
 * and with no way back but the tab bar; checking a figure meant leaving the
 * document. The frame asks for a preview instead, and for printing and
 * downloading to start from there — which the browser's own viewer offers on
 * the document it renders here.
 */
export const PaloDocumentPreview = ({
    url,
    title,
    openLabel,
    closeLabel,
    onClose,
}: PaloDocumentPreviewProps): ReactElement => (
    <PaloModal
        isVisible={Boolean(url)}
        title={title}
        handleClose={onClose}
        width="lg"
        actionChildren={
            <>
                <Button variant="outlined" color="inherit" size="small" href={url ?? ''} target="_blank">
                    {openLabel}
                </Button>
                <Button variant="contained" size="small" onClick={onClose}>
                    {closeLabel}
                </Button>
            </>
        }
    >
        <Box sx={{ height: '72vh', width: '100%' }}>
            {url && <iframe src={url} title={String(title)} style={{ width: '100%', height: '100%', border: 0 }} />}
        </Box>
    </PaloModal>
);
